
export default {
  name: 'BBRadioGroup',
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    tag: {
      type: String,
      default: 'div',
    },
    name: String,
    isMultiple: {
      type: Boolean,
      default: false,
    },
    maxSelected: [Number, String],
    label: String,
    id: String,
    hint: String,
    isPersistentHint: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isDense: {
      type: Boolean,
      default: false,
    },
    isColumn: {
      type: Boolean,
      default: true,
    },
    isRow: {
      type: Boolean,
      default: false,
    },
    backgroundColor: String,
    activeClass: {
      type: String,
      default: 'v-item--active',
    },
    appendIcon: String,
    prependIcon: String,
    isMandatory: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedProps() {
      return {
        tag: this.tag,
        name: this.name,
        multiple: this.isMultiple,
        max: this.maxSelected,
        label: this.label,
        id: this.id,
        hint: this.hint,
        persistentHint: this.isPersistentHint,
        disabled: this.isDisabled,
        dense: this.isDense,
        column: this.isColumn,
        row: this.isRow,
        backgroundColor: this.backgroundColor,
        activeClass: this.activeClass,
        appendIcon: this.appendIcon,
        prependIcon: this.prependIcon,
        mandatory: this.isMandatory,
      };
    },
    radioGroupValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
